import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonService } from '../../../services/common.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-edit-lead',
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule, ReactiveFormsModule],
  templateUrl: './edit-lead.component.html',
  styleUrl: './edit-lead.component.scss'
})
export class EditLeadComponent {
  leadForm: FormGroup;
  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<EditLeadComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.leadForm = this.fb.group({
      email: ['']
    })
  }

}
